/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {Breakpoints, ThemeOptions} from '@mui/material';
import {CSSProperties} from 'react';

import {Tokens} from '../../../types/generated/Tokens';

export const typography = (
  typographyTokens: Tokens['typography'],
  fontTokens: Tokens['font'],
  mediaQueries: Breakpoints
): ThemeOptions['typography'] => {
  const {desktop, mobile} = typographyTokens;
  return {
    fontWeightLight: (fontTokens.weight.light || fontTokens.weight.regular) as CSSProperties['fontWeight'],
    fontWeightRegular: (fontTokens.weight.regular || fontTokens.weight.light) as CSSProperties['fontWeight'],
    fontWeightMedium: (fontTokens.weight.roman || fontTokens.weight.bold) as CSSProperties['fontWeight'],
    fontWeightBold: (fontTokens.weight.xbold || fontTokens.weight.bold) as CSSProperties['fontWeight'],
    fontFamily: typeof fontTokens.family === 'string' ? fontTokens.family : fontTokens.family.sans,

    h1: {
      color: desktop.heading1.fontColor,
      fontFamily: desktop.heading1.fontFamily,
      fontSize: desktop.heading1.fontSize,
      fontWeight: desktop.heading1.fontWeight as CSSProperties['fontWeight'],
      lineHeight: desktop.heading1.lineHeight,

      [mediaQueries.down('sm')]: {
        fontWeight: mobile.heading1.fontWeight as CSSProperties['fontWeight'],
        fontSize: mobile.heading1.fontSize,
        lineHeight: mobile.heading1.lineHeight
      }
    },

    h2: {
      color: desktop.heading2.fontColor,
      fontFamily: desktop.heading2.fontFamily,
      fontSize: desktop.heading2.fontSize,
      fontWeight: desktop.heading2.fontWeight as CSSProperties['fontWeight'],
      lineHeight: desktop.heading2.lineHeight,

      [mediaQueries.down('sm')]: {
        fontWeight: mobile.heading2.fontWeight as CSSProperties['fontWeight'],
        fontSize: mobile.heading2.fontSize,
        lineHeight: mobile.heading2.lineHeight
      }
    },

    h3: {
      color: desktop.heading3.fontColor,
      fontFamily: desktop.heading3.fontFamily,
      fontSize: desktop.heading3.fontSize,
      fontWeight: desktop.heading3.fontWeight as CSSProperties['fontWeight'],
      lineHeight: desktop.heading3.lineHeight,

      [mediaQueries.down('sm')]: {
        fontWeight: mobile.heading3.fontWeight as CSSProperties['fontWeight'],
        fontSize: mobile.heading3.fontSize,
        lineHeight: mobile.heading3.lineHeight
      }
    },

    h4: {
      color: desktop.heading4.fontColor,
      fontFamily: desktop.heading4.fontFamily,
      fontSize: desktop.heading4.fontSize,
      fontWeight: desktop.heading4.fontWeight as CSSProperties['fontWeight'],
      lineHeight: desktop.heading4.lineHeight,

      [mediaQueries.down('sm')]: {
        fontWeight: mobile.heading4.fontWeight as CSSProperties['fontWeight'],
        fontSize: mobile.heading4.fontSize,
        lineHeight: mobile.heading4.lineHeight
      }
    },

    h5: {
      color: desktop.heading5.fontColor,
      fontFamily: desktop.heading5.fontFamily,
      fontSize: desktop.heading5.fontSize,
      fontWeight: desktop.heading5.fontWeight as CSSProperties['fontWeight'],
      lineHeight: desktop.heading5.lineHeight,

      [mediaQueries.down('sm')]: {
        fontWeight: mobile.heading5.fontWeight as CSSProperties['fontWeight'],
        fontSize: mobile.heading5.fontSize,
        lineHeight: mobile.heading5.lineHeight
      }
    },

    h6: {
      color: desktop.heading6.fontColor,
      fontFamily: desktop.heading6.fontFamily,
      fontSize: desktop.heading6.fontSize,
      fontWeight: desktop.heading6.fontWeight as CSSProperties['fontWeight'],
      lineHeight: desktop.heading6.lineHeight,

      [mediaQueries.down('sm')]: {
        fontWeight: mobile.heading6.fontWeight as CSSProperties['fontWeight'],
        fontSize: mobile.heading6.fontSize,
        lineHeight: mobile.heading6.lineHeight
      }
    },

    subtitle1: {
      color: desktop.subtitle1.fontColor,
      fontFamily: desktop.subtitle1.fontFamily,
      fontSize: desktop.subtitle1.fontSize,
      fontWeight: desktop.subtitle1.fontWeight as CSSProperties['fontWeight'],
      lineHeight: desktop.subtitle1.lineHeight,

      '& strong': {
        fontWeight: desktop.subtitle1Bold.fontWeight
      },

      [mediaQueries.down('sm')]: {
        fontSize: mobile.subtitle1.fontSize,
        fontWeight: mobile.subtitle1.fontWeight,
        lineHeight: mobile.subtitle1.lineHeight
      }
    },

    body1: {
      color: desktop.body1.fontColor,
      fontFamily: desktop.body1.fontFamily,
      fontSize: desktop.body1.fontSize,
      fontWeight: desktop.body1.fontWeight as CSSProperties['fontWeight'],
      lineHeight: desktop.body1.lineHeight,

      '& strong': {
        fontWeight: desktop.body1Bold.fontWeight
      },

      [mediaQueries.down('sm')]: {
        fontSize: mobile.body1.fontSize,
        fontWeight: mobile.body1.fontWeight,
        lineHeight: mobile.body1.lineHeight
      }
    },

    body2: {
      color: desktop.body2.fontColor,
      fontFamily: desktop.body2.fontFamily,
      fontSize: desktop.body2.fontSize,
      fontWeight: desktop.body2.fontWeight as CSSProperties['fontWeight'],
      lineHeight: desktop.body2.lineHeight,

      '& strong': {
        fontWeight: desktop.body2Bold.fontWeight
      },

      [mediaQueries.down('sm')]: {
        fontSize: mobile.body2.fontSize,
        fontWeight: mobile.body2.fontWeight,
        lineHeight: mobile.body2.lineHeight
      }
    },

    subtitle2: {
      color: desktop.subtitle2.fontColor,
      fontFamily: desktop.subtitle2.fontFamily,
      fontSize: desktop.subtitle2.fontSize,
      fontWeight: desktop.subtitle2.fontWeight as CSSProperties['fontWeight'],
      lineHeight: desktop.subtitle2.lineHeight,

      '& strong': {
        fontWeight: desktop.body2Bold.fontWeight
      },

      [mediaQueries.down('sm')]: {
        fontSize: mobile.subtitle2.fontSize,
        fontWeight: mobile.subtitle2.fontWeight,
        lineHeight: mobile.subtitle2.lineHeight
      }
    }
  };
};
